export default function getVarsCounter(nthChild, lightBase = 86) {
    const light = lightBase - nthChild * 10;
    const iconLight = lightBase - nthChild * 10 - 5;

    return {
        '--counter-bg': `hsl(250, 66%, ${light}%)`,
        '--counter-icon-clr': `hsl(250, 66%, ${iconLight}%)`,
    }
}
